module.exports = __webpack_public_path__ + "img/collection-memoireRingsHalfSetMemories.75b7fe1.jpg";